import type { FaireProductEntity } from "../../entity_types/product";

export const p_qrskq2ftjq: FaireProductEntity = {
  token: "p_qrskq2ftjq",
  type: "product",
  name: "PS6 2026 Jacquard Embroidered Sleeveless Mini Dress New",
  brandToken: "b_qzzerk93mj",
  brandName: "Productseeker",
  imageUrl:
    "https://cdn.faire.com/fastly/0ce460eef52dbd2b62af97a175f6c4a29ae0c57e592073f40c297c494821042d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/843d610b982f294ba325bda09374f525bf23db7f7447cda82eb38716079dc2f4.png",
    "https://cdn.faire.com/fastly/aeeff219db7db27d6b9834b6c6783c3f941e867a8e3f418b5851e62a9094e50c.png",
    "https://cdn.faire.com/fastly/98afbd42e3261cf88ea04978f9acd0f9d5fc8ae94c7c0b1e60fb69aa0a338063.png",
    "https://cdn.faire.com/fastly/a27b53fe6caeac49f74754e701a257642a09e20e5244cb2b3f169c05c5370cd0.jpeg",
    "https://cdn.faire.com/fastly/4637c181efe9682bcf085fa969e246bbe184d8ef4149b9c28adf44d07616a9ed.jpeg",
    "https://cdn.faire.com/fastly/4c8d0499a18b514f2d99b5d212dbd5a6be67f1a37553bf39664531173f1b8e96.png",
    "https://cdn.faire.com/fastly/f1c25eebddedd38c30a635df2c9740f5f3f96bf81218d9ea6ff72df6a4216c18.jpeg",
    "https://cdn.faire.com/fastly/a13c083c61a6d976c8ec29756eb0970519e708601d10602cd3ed546a66957172.jpeg",
    "https://cdn.faire.com/fastly/3d0064aed947609b9250db6a809363305847334d453b3794bbb262851c768061.jpeg",
    "https://cdn.faire.com/fastly/07de2d589b8e7a37cbee2e2d695477940b41e9532e44e1e3a568836474cc9b56.jpeg",
    "https://cdn.faire.com/fastly/e7b328460b5fdaefb3c46b89dd4c5e9e08b0ca1a08b1f2c98a9ba48f8f1f081d.jpeg",
    "https://cdn.faire.com/fastly/669c42c553558233c6e9604653d16a3d28ff181666290db94fd56def0b70a9ba.jpeg",
    "https://cdn.faire.com/fastly/29dc369162e858352f6d1ac952fea23b31150edfba5d3601a997027b494b5be9.jpeg",
    "https://cdn.faire.com/fastly/f393888e47c114a2c24a1b96bbb89e645dee0d40f8696c42399f60bd6d4dd369.jpeg",
    "https://cdn.faire.com/fastly/a68cc1cf3c387ec4879eb0b6105094be20efcbd93b50aa8ca4173f63858aeb02.jpeg",
    "https://cdn.faire.com/fastly/6792dcac8eca9361250edd06fd99274196d731dfe6a8a0fa41bdcbb4bd92449a.jpeg",
    "https://cdn.faire.com/fastly/43a8bc6c937b9013494746132206ae867a09fa6d06a7b9f6c7ace7d9285aeeac.jpeg",
    "https://cdn.faire.com/fastly/bed15e417054ee92aeb0e935e572dc0335a1ed2505abb8092706cd9961bdb8f3.jpeg",
    "https://cdn.faire.com/fastly/67cad3acca0b55904cddb7c41d340cd8a6bef1495774cdbb06b187b134ae7e93.jpeg",
    "https://cdn.faire.com/fastly/2d24a501801f51c022615a695c7915ebeafdecc5d62d0677052df8487135fd59.jpeg",
    "https://cdn.faire.com/fastly/06ad21de1a7487248f6e94a5bd92915880b9aac0097f36c72981c5b93fb46c02.jpeg",
    "https://cdn.faire.com/fastly/26a2466790035348c4e0460c2c341c5130050fc55197c53a40e7f0b46f7d035d.jpeg",
    "https://cdn.faire.com/fastly/3cc2fc0bff2c2cdaa17b32e32a801ad897ff11677734dc3e87fffa726f2c722b.jpeg",
  ],
  priceDollars: 79,
  description:
    "This 2026 spring and summer sleeveless mini dress features refined jacquard fabric with delicate embroidery, creating rich texture and visual depth. The cropped-length silhouette feels light and modern, while the structured cut enhances a clean, elegant shape. Designed without sleeves for warm-weather comfort, it is easy to style alone or layered with jackets. Perfect for daily wear, vacations, dates, or social gatherings, this dress balances feminine charm and contemporary fashion for a polished yet effortless look.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T17:15:24.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
